// extracted by mini-css-extract-plugin
export default {"payment":"hA","title_row":"iA","border_bottom":"jA","promo_wrapper":"kA","payment_wrapper":"lA","label":"mA","card_row":"nA","cardcontain":"oA","card_input":"pA","card_error":"qA","card_label":"rA","lock":"sA","same_address":"tA","place_order_button":"uA","buttonwrap":"vA","hide_form":"wA","paypal_buttons":"xA","review_button":"yA","alt_payment":"zA"};
    if(module.hot) {
      // 1726593106095
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  